import styled, { css, keyframes } from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const CarouselWrapper = styled.div`
    max-width: 970px;
    margin: 0 auto;

    img {
        max-width: 100%;
    }
`

export const ImageWrapper = styled.div`
    margin-top: 30px;
    text-align: center;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 50px;
    }
`

export const ImageThumbnails = styled.div`
    margin-top: 35px;
    display: flex;
    overflow: auto;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 60px;
    }
`
const widthAnimation = keyframes` 
  0% {
    width: 0;
  } 
  100% {  
    width: 100%; 
  }
`

export const Thumb = styled.div<{ $active: boolean; $completed: boolean; $speed: number; $autoplay: boolean }>`
    border-top: 2px solid ${(props) => props.theme.color.g200};
    flex: 1;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    position: relative;
    cursor: pointer;

    &::after {
        content: '';
        position: absolute;
        z-index: 1;
        top: -2px;
        left: 0;
        width: 0;
        height: 2px;
        background-color: ${(props) => props.theme.color.p500};
    }

    &.active {
        color: ${(props) => props.theme.color.p500};
        ${(props) => props.theme.fontWeight.bold};

        &::after {
            ${(props) =>
                props.$autoplay
                    ? css`
                          animation-name: ${widthAnimation};
                          animation-duration: ${props.$speed}ms;
                      `
                    : css`
                          width: 100%;
                      `}
        }
    }

    ${(props) =>
        props.$completed &&
        `
        border-top-color: ${props.theme.color.p500};
    `}
`

export const Text = styled.span`
    ${(props) => props.theme.fontWeight.regular};
    ${(props) => props.theme.typo.bodyM};
    line-height: 180%;
    padding: 10px;
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`

export const TitleSection = styled(TitleSectionBase)`
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.white)};

    ${Text} {
        color: ${(props) => (props.mode === 'Dark' ? props.theme.color.white : props.theme.color.g500)};
    }
`
